// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vuelidate from 'vuelidate'
import Vuetify from 'vuetify'
import { sync } from 'vuex-router-sync'
import eventBus from '../plugins/event-bus'
import draggable from 'vuedraggable'
import VueClipboard from 'vue-clipboard2'
import VueScrollTo from 'vue-scrollto'

import Moment from 'moment'
import { extendMoment } from 'moment-range'

import '../plugins/axios-config'
import '../plugins/dateformat'
import '../plugins/google-analitics'
import '@/modules/global-components'
import { appLogger } from '../plugins/logger'

sync(store, router)

const moment = extendMoment(Moment)
Object.defineProperty(Vue.prototype, '$moment', { value: moment })
Vue.use(Vuelidate)
Vue.use(Vuetify)
Vue.use(VueClipboard)
Vue.use(VueScrollTo)
Vue.use(appLogger)
Vue.component('drag', draggable)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  data: {
    eventBus
  },
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js